import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import ReduxActions from 'reduxActions';

const JobMobileLineItem = (props) => {
  let dividerColor;
  const jobStatus = props.data.state;

  switch (jobStatus) {
    case 'draft':
      dividerColor = Theme.Color.$bluedarker;
      break;
    case 'submitted':
      dividerColor = Theme.Color.$gold;
      break;
    case 'cancelled':
    case 'rejected':
      dividerColor = Theme.Color.$red;
      break;
    case 'completed':
      dividerColor = Theme.Color.$green;
      break;
    case 'in_progress':
      dividerColor = Theme.Color.$green;
      break;
    default:
  }

  const content = (
    <div className="vf-job__mobile-line-item__content">

      <div className="vf-job__mobile-line-item__content__row">
        <span className="vf-job__mobile-line-item__content__row__title">
          {props.data.guid}
        </span>
        {
          props.data.archived === true ? false : (
            <span className="vf-job__mobile-line-item__content__row__status">
              {props.strings.Job.status[jobStatus]}
            </span>
          )
        }
        {
          props.data.archived === true ? false : (
            <Components.Mobile.Divider
              color={dividerColor}
            />
          )
        }
      </div>

      <div className="vf-job__mobile-line-item__content__row">
        <Components.CircleIcon
          className="vf-job__mobile-line-item__content__row__type-icon"
          iconClassName={
            props.data.job_type === 'pickup' ? 'versa-base-pickup' : 'versa-base-delivery'
          }
          iconText=""
        />
        <div className="vf-job__mobile-line-item__content__row__details">
          <div>{Utils.Formatter.getInlineAddress(props.data.base_task.address)}</div>
          <div>
            {Utils.Formatter.formatRangeTime(props.data.base_task.time_from,
              props.data.base_task.time_to)}
          </div>
        </div>
      </div>
      {
        !Utils.Helper.isNullOrUndefined((props.data || {}).tags) && props.data.tags.length > 0
          ? (
            <Components.Tags
              tags={props.data.tags.map(tag => tag.name)}
            />
          ) : false
      }
    </div>
  );

  let action;
  let iconClassName;
  let onAction;

  switch (props.data.state) {
    case 'draft':
      action = 'Submit';
      iconClassName = 'versa-business';
      onAction = () => {
        Utils.FullScreenLoading.FullScreenLoadingManager.open(
          props.strings.Job.page.submittingItem,
        );
        props.dispatch(ReduxActions.job.submit(props.data.id))
          .then(() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              props.strings.Job.page.loadingItems,
            );
            return props.dispatch(ReduxActions.job.fetchList());
          })
          .then(() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.close();
          });
      };
      break;
    case 'rejected':
      action = 'Resubmit';
      iconClassName = 'versa-business';
      onAction = () => {
        Utils.FullScreenLoading.FullScreenLoadingManager.open(
          props.strings.Job.page.resubmittingItem,
        );
        props.dispatch(ReduxActions.job.submit(props.data.id))
          .then(() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              props.strings.Job.page.loadingItems,
            );
            return props.dispatch(ReduxActions.job.fetchList());
          })
          .then(() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.close();
          });
      };
      break;
    case 'submitted':
      action = 'Retract';
      iconClassName = 'versa-retract';
      onAction = () => {
        Utils.FullScreenLoading.FullScreenLoadingManager.open(
          props.strings.Job.page.retractingItem,
        );
        props.dispatch(ReduxActions.job.revoke(props.data.id))
          .then(() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              props.strings.Job.page.loadingItems,
            );
            return props.dispatch(ReduxActions.job.fetchList());
          })
          .then(() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.close();
          });
      };
      break;
    case 'in_progress':
    case 'completed':
      break;
    default:
  }

  return (
    <Components.Mobile.LineItem
      action={action}
      actionId={`${props.id}__${action}`}
      className="vf-job__mobile-line-item"
      content={content}
      iconClassName={iconClassName}
      iconText=""
      id={props.id}
      onAction={onAction}
      onClick={() => Utils.Router.transitionFromSubpath('jobs', props.data.id)}
    />
  );
};

JobMobileLineItem.propTypes = {
  data: PropTypes.shape({
    state: PropTypes.string,
    guid: PropTypes.string,
    archived: PropTypes.bool,
    base_task: PropTypes.shape(),
    job_type: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    time_type: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  id: PropTypes.string.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      status: PropTypes.shape(),
      page: PropTypes.shape({
        submittingItem: PropTypes.string,
        loadingItems: PropTypes.string,
        resubmittingItem: PropTypes.string,
        retractingItem: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default connect()(translate('')(JobMobileLineItem));
